import { formatTimestamp } from "swyft-react-core";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Grid } from "@material-ui/core";

import { Quote } from "../../../../api/Quote/Quote";
import { quoteImage } from "../../../../app/utils";
import { EQuoteStatus } from "../../../../api/Quote/EQuoteStatus";
import { SelectedQuoteBanner } from "./SelectedQuoteBanner";
import { NewQuoteBanner } from "./NewQuoteBanner";
import { quoteBoxStyles } from "./quoteBox.style";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { PriceFormat } from "../../../../components/typography/PriceFormat";

interface QuoteProps {
  quote: Quote;
}
export const QuoteBox = ({ quote }: QuoteProps) => {
  const classes = quoteBoxStyles();
  const { isMoreThanSm, isMoreThanMd } = useBreakpoint();

  const image = quoteImage(quote);
  return (
    <Box
      boxShadow={"0 5px 15px 0 rgba(0, 0, 0, 0.07)"}
      borderRadius={"10px"}
      mb={3}
      p={2}
      textAlign="center"
      position="relative"
      className={classes.root}
    >
      <Box position="absolute" top="8px" right="8px">
        {quote.status === EQuoteStatus.Approved ||
        quote.status === EQuoteStatus.Paid ||
        quote.status === EQuoteStatus.Payment ? (
          <SelectedQuoteBanner />
        ) : (
          !quote.viewed && <NewQuoteBanner />
        )}
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {image && (
            <Box p={2} className={classes.productImage}>
              <img src={image} alt="Product" />
            </Box>
          )}
        </Grid>
        <Grid item xs={12}>
          <Box
            component="h2"
            fontWeight={500}
            fontSize={isMoreThanMd ? "22px" : "18px"}
            color={"#160037"}
            mt={0}
            letterSpacing={"0.36px"}
            className={classes.packageTitle}
          >
            {quote.title}
          </Box>
          <Box component={"h1"} fontWeight={500} fontSize={isMoreThanSm ? "22px" : "18px"} color={"#160037"}>
            <PriceFormat value={quote.price} />
          </Box>

          <Box textAlign="left" mt={3}>
            <Box
              maxWidth={"320px"}
              mx="auto"
              display={"flex"}
              justifyContent={"space-between"}
              mb={1}
              fontWeight={400}
              fontSize={isMoreThanSm ? "16px" : "14px"}
              color={"#4b5462"}
            >
              <Box component={"p"} m={0}>
                Ref No:
              </Box>
              <Box component={"p"} m={0}>
                {quote.name}
              </Box>
            </Box>
            <Box
              maxWidth={"320px"}
              mx="auto"
              display={"flex"}
              justifyContent={"space-between"}
              mb={1}
              fontWeight={400}
              fontSize={isMoreThanSm ? "16px" : "14px"}
              color={"#4b5462"}
            >
              <Box component={"p"} m={0}>
                Quote Sent:
              </Box>
              <Box component={"p"} m={0}>
                {formatTimestamp(quote.sent || quote.created, true, true)}
              </Box>
            </Box>
            <Box
              maxWidth={"320px"}
              mx="auto"
              display={"flex"}
              justifyContent={"space-between"}
              fontWeight={400}
              fontSize={isMoreThanSm ? "16px" : "14px"}
              color={"#4b5462"}
            >
              <Box component={"p"} m={0}>
                Valid Until:
              </Box>
              <Box component={"p"} m={0}>
                {formatTimestamp((quote.sent || quote.created) + 30 * 24 * 60 * 60 * 1000, true, true)}
              </Box>
            </Box>
          </Box>

          <Box display="flex" justifyContent="center" mt={isMoreThanSm ? "25px" : "40px"} maxWidth={"320px"} mx="auto">
            <Button
              component={RouterLink}
              to={`/quote/${quote.id}`}
              color="secondary"
              variant="contained"
              className={classes.buttonViewQuote}
            >
              View Quote
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
